const BASE_URL = `/Sitemanagement`

export const getPayform = async (exhibitor) => {
    try {
        const res = await fetch(`${BASE_URL}/ConstructPayform`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(exhibitor),
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (err) {
        throw err
    }
}

export const getConfirmation = async (paymentForm) => {
    try {
        const res = await fetch(`${BASE_URL}/Confirmation`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(paymentForm),
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (err) {
        throw err
    }
}